var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTrialExpiredBg = function SvgTrialExpiredBg(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 410.04 610",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 5688"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#194377",
    d: "M0 0h410v586H0z",
    "data-name": "Rechteck 1837"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 5686"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#275894",
    d: "M214.07 293.622c-50.808-3.989-76.84-6.1-113.27 18.827S0 287.985 0 287.985v322.016h410.04V267.119s-30.841 37.226-68.137 41.89-20.744 2.4-59.7-15.388-17.325 3.988-68.133.001",
    "data-name": "Pfad 1378"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTrialExpiredBg);
export default ForwardRef;